const trustAsUrl = function ($sce) {
  return url => $sce.trustAsResourceUrl(url);
};

trustAsUrl.$inject = ['$sce'];

export default trustAsUrl;
